export const PIPELINES = [
  { name: 'Backend infrastructure', repo: 'libride_backend',      branch: 'dev',  account: '502309351201', approval: 'None',     security: 'Disabled' },
  { name: 'Backend infrastructure', repo: 'libride_backend',      branch: 'uat',  account: '225635014870', approval: 'Required', security: 'Enabled'  },
  { name: 'Backend infrastructure', repo: 'libride_backend',      branch: 'main', account: '821080507864', approval: 'Required', security: 'Enabled'  },
  { name: 'Admin portal (frontend)', repo: 'libride_admin_portal', branch: 'dev',  account: '502309351201', approval: 'None',     security: 'Disabled' },
  { name: 'Admin portal (frontend)', repo: 'libride_admin_portal', branch: 'uat',  account: '225635014870', approval: 'Required', security: 'Enabled'  },
  { name: 'Admin portal (frontend)', repo: 'libride_admin_portal', branch: 'main', account: '821080507864', approval: 'Required', security: 'Enabled'  },
];

export const PIPELINE_STAGES_DONE = [
  <><strong>Source</strong> — CodeCommit trigger on branch push (dev / uat / main)</>,
  <><strong>Build</strong> — CodeBuild: <code>npm install</code>, TypeScript compile, <code>cdk synth</code></>,
  <><strong>Test</strong> — Unit tests and CDK snapshot tests</>,
  <><strong>Security</strong> — cdk-nag AWS Solutions checks (dev: disabled for speed; UAT + Prod: enabled, blocks on violations)</>,
  <><strong>Approval</strong> — Manual approval gate before deploy (UAT + Prod only; email notification to <code>elijah.adadzi@gmail.com</code>)</>,
  <><strong>Deploy</strong> — CodeBuild assumes cross-account deployment role and runs <code>cdk deploy</code></>,
];

export const PIPELINE_STAGES_TODO: string[] = [];

export const CROSS_ACCOUNT_DONE = [
  <>CICD account (<code>322156488575</code>) hosts all pipeline stacks — no application resources deployed here</>,
  <>Dev build and deploy roles created — pipeline deploys to Dev account (<code>502309351201</code>)</>,
  <>UAT build and deploy roles created — pipeline deploys to UAT account (<code>225635014870</code>)</>,
  <>Prod build and deploy roles created — pipeline deploys to Prod account (<code>821080507864</code>)</>,
];

export const CROSS_ACCOUNT_TODO: string[] = [];

export const MOBILE_BUILDS_DONE = [
  <><code>testflight</code> (iOS) and <code>internal</code> (Android) EAS build profiles defined</>,
  <>Local builds: <code>eas build --profile testflight --platform ios --local</code></>,
];

export const MOBILE_BUILDS_TODO: string[] = [];
